import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetIpSetQuery } from "../../store/api/ipSetApi";
import { IpSetDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "ipset";
export const IpSetDetailInitializer: React.FC = () => {
  const { org: orgName, ipset: ipsetName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/ipset/${ipsetName}`;

  const { data: ipSet, isLoading, isFetching, isError, error, refetch } = useGetIpSetQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!ipSet && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="ipset" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !ipSet) {
    return <IncorrectItem kind="ipset" canCreate={true} />;
  }

  return <IpSetDetailForm ipSet={ipSet} />;
};
